<template>
    <div class="gps-card">
        <div class="gps-card__header">
            <div class="gps-card__header-left">
                <slot name="header-extra"></slot>
                <div class="gps-card__title">{{ title }}</div>
            </div>
            <div class="gps-card__matches" v-if="data.matches_count">
                {{ data.matches_count }} {{ matchWord }}
            </div>
        </div>
        <div class="gps-card__body">
            <div
                v-for="(row, idx) in rows"
                :key="row.key"
                class="gps-card__row"
                :class="{ 'gps-card__row--alt': idx % 2 === 0 }"
            >
                <span class="gps-card__label">{{ row.label }}</span>
                <span class="gps-card__value">{{ row.value }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GpsStatsTable',

    props: {
        title: {
            type: String,
            required: true
        },
        data: {
            type: Object,
            required: true
        }
    },

    computed: {
        rows() {
            if (!this.data) return []
            return [
                { key: 'total_distance', label: 'Загальна дистанція', value: this.formatDistance(this.data.total_distance) },
                { key: 'zone_4', label: 'Зона 4', value: this.formatDistance(this.data.zone_4) },
                { key: 'zone_5', label: 'Зона 5', value: this.formatDistance(this.data.zone_5) },
                { key: 'zone_6', label: 'Зона 6', value: this.formatDistance(this.data.zone_6) },
                { key: 'speed_distance', label: 'Швидкісна дист.', value: this.formatDistance(this.data.speed_distance) },
                { key: 'average_speed', label: 'Середня швидкість', value: this.formatUnit(this.data.average_speed, 'м/с') },
                { key: 'max_speed', label: 'Макс. швидкість', value: this.formatUnit(this.data.max_speed, 'км/г') },
                { key: 'sprints', label: 'Спринти', value: this.formatNumber(this.data.sprints) },
                { key: 'starts', label: 'Старт', value: this.formatNumber(this.data.starts) },
                { key: 'stops', label: 'Стоп', value: this.formatNumber(this.data.stops) }
            ]
        },
        matchWord() {
            const count = this.data.matches_count || 0
            if (count === 1) return 'матч'
            if (count >= 2 && count <= 4) return 'матчі'
            return 'матчів'
        }
    },

    methods: {
        formatDistance(metres) {
            if (metres == null || metres === 0) return '—'
            return Number(metres).toLocaleString('uk-UA') + ' м'
        },

        formatUnit(value, unit) {
            if (value == null || value === 0) return '—'
            return value + ' ' + unit
        },

        formatNumber(value) {
            if (value == null) return '—'
            return Number(value).toLocaleString('uk-UA')
        }
    }
}
</script>

<style scoped>
.gps-card {
    background: linear-gradient(145deg, #2a2b2b 0%, #252626 100%);
    border: 1px solid #3a3b3b;
    border-radius: 14px;
    padding: 14px 16px 10px;
    height: 100%;
}
.gps-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 10px;
}
.gps-card__header-left {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}
.gps-card__title {
    color: #C59014;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.3px;
    white-space: nowrap;
}
.gps-card__matches {
    color: #6b6b6b;
    font-size: 11px;
    flex-shrink: 0;
}
.gps-card__body {
    display: flex;
    flex-direction: column;
    gap: 1px;
}
.gps-card__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 8px;
    border-radius: 6px;
    transition: background 0.15s;
}
.gps-card__row--alt {
    background: rgba(58, 59, 59, 0.5);
}
.gps-card__row:hover {
    background: rgba(197, 144, 20, 0.08);
}
.gps-card__label {
    color: #a68a3a;
    font-size: 13px;
}
.gps-card__value {
    color: #f0e6cc;
    font-size: 13px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
}
</style>
